const driver = {

  request (req, token) {
    const refresh = req.url.indexOf('refresh') > -1
    token = token.split(';')
    if (!refresh) {
      token = token[0]
      this.options.http._setHeaders.call(this, req, {Authorization: 'Bearer ' + token})
    } else {
      token = token[1]
      this.options.http._setHeaders.call(this, req, {Authorization: 'Bearer ' + token})
    }
  },

  response (res) {
    // console.log(new Date(), res)
    if (res.data && res.data.access_token && res.data.refresh_token && res.data.expiration) {
      return res.data.access_token + ';' + res.data.refresh_token + ';' + res.data.expiration
    }
  }
}

export default driver
